import React from 'react';
import { SwitchLabel, SwitchButton, SwitchContainer } from './styles';

const FormSwitch = ({ id = '', disabled = false, value = true, handleSwitchChange = () => {} }) => {
  return (
    <SwitchContainer data-publi='professionalPubli-switchContainer'>
      <SwitchLabel data-panel={`switch-${id}`} checked={value} disabled={disabled} onClick={handleSwitchChange}>
        <SwitchButton checked={value} />
      </SwitchLabel>
    </SwitchContainer>
  );
};

export default FormSwitch;
